import React from 'react';
import { useT } from '../../../../i18n';

type Status = 'wait' | 'ok' | 'no';

// La liste d'invités : une famille arrive en haut, puis Julie passe à « Oui ».
const GuestsVisual: React.FC = () => {
  const t = useT();
  const pill = (s: Status) => <span className={`mk-fv-pill is-${s}`}>{t(s === 'ok' ? 'Oui' : s === 'no' ? 'Non' : 'En attente')}</span>;
  const row = (name: string, group: string, status: React.ReactNode, className = '') => (
    <div className={`mk-fv-guest ${className}`}>
      <i />
      <span>{name}</span>
      <em>{group}</em>
      {status}
    </div>
  );
  return (
    <div className="mk-fv-stage">
      <div className="mk-fv-box mk-fv-guests">
        <div className="mk-fv-guests-head">
          <b>
            {t('Invités')} · <span className="mk-fv-count" />
          </b>
          <span className="mk-fv-search">⌕ {t('Rechercher')}</span>
        </div>
        <div className="mk-fv-guests-window">
          <div className="mk-fv-guests-list">
            {row('Famille Roux', `${t('Famille')} · 4`, pill('wait'), 'is-new')}
            {row(
              'Julie Martin',
              t('Amis'),
              <span className="mk-fv-flip">
                {pill('wait')}
                {pill('ok')}
              </span>,
            )}
            {row('Paul & Inès', `${t('Amis')} · 2`, pill('ok'))}
            {row('Mamie Jeanne', t('Famille'), pill('ok'))}
            {row('Tom Bernard', t('Collègues'), pill('no'))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default GuestsVisual;
